import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mrbox round darkfill menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Opties", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.trail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_router_link, {
          to: {
      name: 'TrailIntroduction',
      params: {
        trailid: _ctx.$route.params.trailid,
        slug: _ctx.$route.params.slug
      }
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" route-introductie ")
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.showDescription)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent","stop"])),
              onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
            }, " routebeschrijving", 32))
          : _createCommentVNode("", true),
        (_ctx.showGps)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent","stop"])),
              onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
            }, "GPS Informatie", 32))
          : _createCommentVNode("", true),
        (_ctx.showMap)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: "",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent","stop"])),
              onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
            }, _toDisplayString(_ctx.mapLabel), 33))
          : _createCommentVNode("", true),
        (_ctx.showPrint)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: "",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent","stop"])),
              onKeypress: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
            }, " Afdrukken", 32))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: {
      name: 'TrailReaction',
      params: {
        trailid: _ctx.$route.params.trailid,
        slug: _ctx.$route.params.slug
      }
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Plaats een reactie ")
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}